import { render } from "./protocol_inside_positions.vue?vue&type=template&id=3c5b41f2&scoped=true"
import script from "./protocol_inside_positions.vue?vue&type=script&lang=js"
export * from "./protocol_inside_positions.vue?vue&type=script&lang=js"

import "./protocol_inside_positions.vue?vue&type=style&index=0&id=3c5b41f2&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5b41f2"],['__file',"vue/js/components/sale/protocol/inside/block/protocol_inside_positions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c5b41f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c5b41f2', __exports__)) {
    console.log('reload')
    api.reload('3c5b41f2', __exports__)
  }
  
  module.hot.accept("./protocol_inside_positions.vue?vue&type=template&id=3c5b41f2&scoped=true", () => {
    console.log('re-render')
    api.rerender('3c5b41f2', render)
  })

}


export default __exports__